import { Component, ViewChild } from '@angular/core';
import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';
import { NgForm } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { UsersResource } from '../../account/resources/users.resource';
import { User } from '../../account/user.models';
import { NotifyService } from '../../common/services/notify.service';
import { ConfirmationDialogService } from '../../common/services/confirmation-dialog.service';
import { DialogType } from '../../common/services/components/dialog-template.component';

@Component({
  selector: 'settings-tokens',
  template: `
    <div class="settings-body">
      <h2>{{ 'tokens.title' | translate }}</h2>
      <p [innerHTML]="'tokens.description' | translate"></p>
      <form name="apiKeyForm" (ngSubmit)="getApiKey()" *ngIf="!user.api_key">
        <div class="form-group">
          <label for="tokens">{{ 'tokens.form.label' | translate }}</label>
          <input
            type="password"
            name="current_password"
            class="form-control"
            id="tokens"
            [(ngModel)]="user.current_password"
            placeholder="{{ 'tokens.form.placeholder' | translate }}"
          />
        </div>
        <xp-submit-button
          classNames="btn-md btn-success"
          updateText="{{ 'tokens.form.button' | translate }}"
          [isFormValid]="true"
          [isFormSubmitting]="isSubmitting"
        ></xp-submit-button>
      </form>
      <div *ngIf="user.api_key">
        <div class="form-group">
          <pre class="input"><code>{{ user.api_key }}</code></pre>
        </div>
        <button type="button" class="btn btn-md btn-danger" (click)="reset()">
          {{ 'tokens.form.button-reset' | translate }}
        </button>
      </div>
    </div>
  `,
})
export class SettingsTokensComponent {
  user: Partial<User> = {};
  @ViewChild('form') form: NgForm;
  isSubmitting = false;
  formName = 'userForm';

  constructor(
    private usersResource: UsersResource,
    protected notify: NotifyService,
    protected translate: TranslateService,
    private confirmationDialog: ConfirmationDialogService,
  ) {
    usersResource.get().subscribe({
      next: (user) => {
        this.user = user;
      },
      error: () => {
        this.notify.error('An error occurred while loading user data.');
      },
    });
  }

  getApiKey() {
    this.usersResource
      .show_api_key({
        current_password: this.user.current_password,
      })
      .subscribe({
        next: (user) => {
          if (user.api_key) {
            this.user.api_key = user.api_key;
          } else {
            const errorMessage = user.sso_error
              ? 'tokens.form.sso-error-message-text'
              : 'tokens.form.error-message-text';
            this.notify.warn(this.translate.instant(errorMessage));
          }
        },
        error: () => {
          this.notify.error('An error occurred while loading user data.');
        },
      });
  }

  reset() {
    const dialogRef = this.confirmationDialog.openDialog({
      title: this.translate.instant('tokens.confirm.title'),
      hint: this.translate.instant('tokens.confirm.hint'),
      yes: this.translate.instant('tokens.confirm.yes'),
      no: this.translate.instant('tokens.confirm.no'),
      type: DialogType.danger,
    });

    dialogRef.afterClosed().subscribe((isConfirmed) => {
      if (isConfirmed) {
        this.usersResource.regenerate_tokens().subscribe({
          next: (user) => {
            this.user.api_key = user.api_key;
          },
          error: () => {
            this.notify.error('An error occurred while getting data.');
          },
        });
      }
    });
  }
}

((window as any).xplenty as angular.IModule).directive(
  'settingsTokens',
  downgradeComponent({
    component: SettingsTokensComponent,
  }),
);
